import AcceptDesign from "@configuratorware/configurator-frontendgui/App/Shared/Components/AcceptDesign";
import AddToCart from "@configuratorware/configurator-frontendgui/App/Shared/Components/AddToBasket";
import AnalyticsWrapper from "@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper";
import Notification from "@configuratorware/configurator-frontendgui/App/Shared/Components/Notification";
import PriceOverview from "@configuratorware/configurator-frontendgui/App/Shared/Components/PriceOverview";
import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import MainButton from "@configuratorware/configurator-frontendgui/Shared/Components/MainButton";
import {
  Button,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Icon from "@material-ui/core/Icon/Icon";
import RootRef from "@material-ui/core/RootRef/RootRef";
import Typography from "@material-ui/core/Typography/Typography";
import clsx from "clsx";
import { get } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import CategorySelectorDialog from "../../Containers/CategorySelectorDialog/CategorySelectorDialog";
import Outfit from "../Outfit/Outfit";

export const useStyles = makeStyles(
  (theme) => ({
    contentPositioning: {
      paddingLeft: 32,
      paddingRight: 20,
      [theme.breakpoints.down("xs")]: {
        paddingLeft: 0,
        paddingRight: 8,
        marginRight: "-8px",
      },
      "& p": {
        fontSize: 15,
        letterSpacing: "normal",
      },
      marginRight: 4,
      padding: 0,
    },
    dialogWrapper: {
      borderTop: "7px solid " + theme.palette.primary.main,
      padding: "0 32px",
      overflow: "hidden",
      [theme.breakpoints.down("xs")]: {
        padding: "0px",
      },
      "& hr": {
        height: 0,
      },
    },
    toOverview: {
      backgroundColor: "#fff",
      boxShadow: "none",
      border: 0,
      textTransform: "none",
      "& span": {
        textDecoration: "underline",
      },
      "&:hover": {
        backgroundColor: "#fff",
      },
    },
    gridContainer: {
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        alignItems: "center",
        borderTop: "1px solid #9e9e9e",
      },
    },
    configurationSwitch: {
      [theme.breakpoints.down("xs")]: {
        margin: "0px 8px",
      },
    },
    cardUnboxed: {
      borderTop: "none",
      boxShadow: "none",
      marginTop: 8,
      marginRight: 15,
      backgroundColor: "transparent",
      [theme.breakpoints.down("xs")]: {
        display: "flex",
      },
    },
    dialogPositioning: {
      overflow: "hidden",
      "& .MuiDialog-container": {
        "& .MuiDialogTitle-root": {
          paddingTop: 25,
          paddingBottom: 15,
          "& p, h2": {
            fontSize: 24,
            fontWeight: "bold",
            letterSpacing: "normal",
          },
        },
        "& .MuiDialogActions-root": {
          paddingBottom: 24,
          [theme.breakpoints.down("xs")]: {
            marginRight: 0,
          },
          marginRight: 8,
        },
        "& .MuiDialogTitle-root, .MuiDialogActions-root": {
          paddingLeft: 32,
          paddingRight: 32,
          [theme.breakpoints.down("xs")]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          "& p": {
            fontSize: 15,
            letterSpacing: "normal",
          },
        },
      },
      "& .MuiButton-root": {
        height: 40,
        textTransform: "none",
        minWidth: 140,
        marginTop: 8,
        color: get(theme, "palette.primary.darkText", "#282828"),
        [theme.breakpoints.down("xs")]: {
          height: 56,
        },
      },
    },
    modeSwitchButton: {
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff",
      },
    },
    mainButton: {
      margin: "8px  0px 0px",
      padding: "6px 15px",
      height: 40,
      lineHeight: 1.5,
      [theme.breakpoints.down("xs")]: {
        height: 56,
      },
    },
    mainButtonLabel: {
      [theme.breakpoints.down("xs")]: {
        whiteSpace: "normal",
        fontSize: 12,
      },
    },
    closeIcon: {
      position: "absolute",
      right: 32,
      top: 32,
      [theme.breakpoints.down("xs")]: {
        right: 16,
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
    dialogTitleRoot: {
      padding: "20px 0",
    },
  }),
  { name: "CustomAmountPrice" }
);

const DialogActionsWrapper = ({ onTouchMove, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const { current } = ref;
    if (current) {
      current.addEventListener("touchmove", onTouchMove, { passive: false });
    }
    return () => {
      if (current) {
        current.removeEventListener("touchmove", onTouchMove, false);
      }
    };
  }, [onTouchMove]);
  return (
    // as of material-ui v3.x the refs are not forwarded, so the only way to get it is using RootRef
    // FIXME check after updating material-ui
    <RootRef rootRef={ref}>
      <DialogActions {...props} />
    </RootRef>
  );
};

DialogActionsWrapper.propTypes = {
  onTouchMove: PropTypes.func,
};

const AmountPrice = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const dialogContentRef = useRef<HTMLDivElement>(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [showPriceOverview, setShowPriceOverview] = useState(false);
  const [notice, setNotice] = useState("");
  const [bulkNameErrors, setBulkNameErrors] = useState([]);
  const [image, setImage] = useState(null);
  const [showErrors, setShowErrors] = useState(false);
  // @ts-ignore
  const { showSelector } = useSelector((state) => state.basket);
  const { setShowSelector } = props;

  useEffect(() => {
    const { bulkNameErrors } = props;
    setBulkNameErrors(bulkNameErrors);
  }, [props.bulkNameErrors]);

  useEffect(() => {
    const { error } = props;
    if (error && dialogContentRef.current) {
      dialogContentRef.current.scrollTo(0, 0);
    }
  }, [props.error]);

  useEffect(() => {
    const { onShowChange } = props;
    onShowChange && onShowChange(showPriceOverview);
  }, [showPriceOverview]);

  const verifyRequestErrors = () => {
    const { bulkNameErrors } = props;
    if (bulkNameErrors && bulkNameErrors.length > 0) {
      setShowErrors(true);
      setBulkNameErrors(bulkNameErrors);
      dialogContentRef.current.scrollTo(0, 0);
    }
  };

  const requestHasErrors = () => {
    const { bulkNameErrors } = props;
    if (bulkNameErrors && bulkNameErrors.length > 0) {
      return true;
    }
    return false;
  };

  const onAddToBasket = async () => {
    const { onAddToBasket } = props;
    if (!requestHasErrors()) {
      onAddToBasket();
      handleClose();
    } else {
      verifyRequestErrors();
    }
  };

  const handleTouchMove = (evt) => {
    const dialogContent = dialogContentRef.current;
    evt.preventDefault();
    dialogContent.scrollTo(0, dialogContent.scrollTop);
  };

  const openPriceOverview = async () => {
    const screenshot = await props.getScreenshotImage();
    setImage(screenshot);
    try {
      await props.validateConfiguration();
      setShowPriceOverview(!showPriceOverview);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`Error while validating configuration: ${e}`);
    }
  };

  const handleClose = () => {
    setShowPriceOverview(false);
    setBulkNameErrors([]);
    setShowErrors(false);
    props.onClose();
  };

  const handleBasketNoticeChange = (event) => {
    setNotice(event.target.value);
    props.setConfigurationComment(event.target.value);
  };

  const renderPriceOverview = () => {
    const {
      amount,
      priceFormatted,
      showProductVariants,
      error,
      vatNotice,
      clientTexts,
      // displayAcceptDesign,
      notifications,
      showCallToAction,
      isLoggedIn,
      title,
      ProductVariantComponent,
    } = props;

    const displayAcceptDesign = false;

    const { termsAndConditionsLink } = clientTexts;
    const mergedNotifications = [...notifications] || [];

    if (showErrors && bulkNameErrors && bulkNameErrors.length > 0) {
      bulkNameErrors.map((error) => {
        mergedNotifications.push({
          message: error,
          level: "error",
          color: "error",
        });
      });
    }

    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{
          paper: classes.dialogWrapper,
          root: classes.dialogPositioning,
        }}
        BackdropProps={{ className: classes.dialogPositioning }}
        onClose={handleClose}
        open={showPriceOverview}
        maxWidth={"md"}
        fullWidth
        fullScreen={isSmallScreen}
        scroll="paper"
      >
        <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
          <Typography variant="body1">
            <b>
              {t(
                !isLoggedIn
                  ? "amountPrice.intoRequestList"
                  : "amountPrice.intoCart"
              )}
            </b>
          </Typography>
          <Icon className={classes.closeIcon} onClick={handleClose}>
            close
          </Icon>
        </DialogTitle>
        <RootRef rootRef={dialogContentRef}>
          <DialogContent classes={{ root: classes.contentPositioning }}>
            <PriceOverview
              contactData={t("amountPrice.contactData")}
              handleClose={handleClose}
              amount={amount}
              acceptDesignComponent={
                showCallToAction ? (
                  <AcceptDesign
                    termsAndConditionsLink={termsAndConditionsLink}
                    displayAcceptDesign={false}
                    closeProductOverviewDialog={handleClose}
                    notice={notice}
                    noteLabel={t("amountPrice.notice")}
                    handleChange={handleBasketNoticeChange}
                  />
                ) : null
              }
              notificationComponent={mergedNotifications.map(
                ({ message, level, color }, key) => {
                  return (
                    <Notification
                      key={key}
                      icon={level}
                      color={color}
                      notification={message}
                    />
                  );
                }
              )}
              priceListComponent={null}
              productVariantComponent={
                showProductVariants && (
                  <ProductVariantComponent title={title} image={image} />
                )
              }
              receiveOfferFormComponent={null}
              showReceiveOfferForm={false}
            />
          </DialogContent>
        </RootRef>
        <DialogActionsWrapper onTouchMove={handleTouchMove}>
          <AddToCart
            buttonLabel={t(
              !isLoggedIn
                ? "amountPrice.intoRequestList"
                : "amountPrice.intoCart"
            )}
            showCallToAction={showCallToAction}
            onPress={onAddToBasket}
            handleChange={handleBasketNoticeChange}
            disabled={amount == 0 ? true : false && !!error}
            totalPrice={priceFormatted}
            taxNote={vatNotice}
            showPriceList={false}
            priceListLabel={t("amountPrice.showPriceList")}
            priceListClick={() => {}}
            hidePrices={true}
            amount={amount}
            showReceiveOfferForm={false}
          />
        </DialogActionsWrapper>
      </Dialog>
    );
  };

  const {
    showCallToAction,
    wrapperClass,
    showConfigurationModeSwitch,
    isLoggedIn,
    ConfigurationModeSwitchComponent,
  } = props;

  return (
    <React.Fragment>
      <Card
        className={clsx(
          classes.cardUnboxed,
          wrapperClass,
          customClassName("cta-box")
        )}
      >
        <Grid className={classes.gridContainer} item xs={12} sm={12}>
          <Grid item xs={showCallToAction ? 4 : 12} sm={12}>
            <Button
              variant="outlined"
              fullWidth
              size="medium"
              className={classes.toOverview}
              onClick={() =>
                history.push({
                  pathname: "/products/overview",
                  search: window.location.search,
                })
              }
            >
              {t("amountPrice.toOverview")}
            </Button>
          </Grid>

          {showConfigurationModeSwitch && (
            <Grid
              className={classes.configurationSwitch}
              item
              xs={showCallToAction ? 4 : 12}
              sm={12}
            >
              <ConfigurationModeSwitchComponent
                className={clsx(
                  classes.modeSwitchButton,
                  customClassName("configuration-type-button")
                )}
                classes={{
                  root: classes.mainButton,
                  label: classes.mainButtonLabel,
                }}
              />
            </Grid>
          )}

          {showCallToAction && (
            <Grid item xs={showConfigurationModeSwitch ? 4 : 12} sm={12}>
              <AnalyticsWrapper targetId="add_to_cart">
                <MainButton
                  className={customClassName("cta-button")}
                  variant="contained"
                  fullWidth
                  size="medium"
                  onClick={openPriceOverview}
                  classes={{
                    root: classes.mainButton,
                    label: classes.mainButtonLabel,
                  }}
                >
                  {t(
                    !isLoggedIn
                      ? "amountPrice.intoRequestList"
                      : "amountPrice.intoCart"
                  )}
                </MainButton>
              </AnalyticsWrapper>
            </Grid>
          )}
        </Grid>
      </Card>

      {showPriceOverview && renderPriceOverview()}
      {props.isOutfitVisble && props.screenshot && (
        <Outfit
          onClose={() => props.onCloseOutfit()}
          isOutfitOpen={props.isOutfitVisble}
          isSmallScreen={isSmallScreen}
          DialogActionsWrapper={DialogActionsWrapper}
          activeItemImage={props.screenshot}
        />
      )}
      {showSelector && (
        <CategorySelectorDialog
          show={showSelector}
          onClose={() => setShowSelector(false)}
        />
      )}
    </React.Fragment>
  );
};

export default AmountPrice;
